import React, { useState, useEffect } from 'react';
import {Button, Modal, Form, Dropdown, ButtonGroup, Container, Row, Col, Badge, InputGroup, Card} from 'react-bootstrap';
import SelectParam from './selectores/SelectParam';
import SelectParamTest from './selectores/SelectParamTest';


function ListadoDetalleIngresoCam (props) {
  console.log('props.datosDetalleCAM', props.dataDetalle)
  //const haydetalleCam = props.haydetalleCam;
  //const dataCam = props.dataDetalle;
  //const [dataCam, setDataCam] = useState(props.dataDetalle);
  //console.log('props.dataDetalle', props.dataDetalle);
  
  //const [haydetalleCam, setHaydetalleCam] = useState(props.haydetalleCam);
  const patron1 = props.haydetalleCam?props.dataDetalle.patron1.descripcion:'Patron 1';
  const patron2 = props.haydetalleCam?props.dataDetalle.patron2.descripcion:'Patron 2';
  //console.log('dataCam', dataCam);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const ejecutarAccion = () => {
    props.borraCam();
    setShow(false);
    // 👉 AQUÍ VA LA ACCIÓN REAL
    //console.log('Acción confirmada y ejecutada');
    //alert('Acción ejecutada con éxito');
  };

 
  return (
    <>
                <Row>
                    <Card >
                        <Card.Header><span className="titulo-card">SERIE EPP </span></Card.Header>
                    </Card>
                </Row>
                <Row>
                    <Col xs={6} md={4}>
                        <InputGroup id="input-serie-epp">
                            <InputGroup.Text >{props.cod_epp}-</InputGroup.Text>
                            <Form.Control
                            disabled={props.haydetalleCam?true:false}
                            value={props.serieFormEpp}
                            onChange={props.cambioEnEppCam}
                            name="serie"
                            type="number"
                            placeholder="Serie epp"
                            />
                        </InputGroup>
                    </Col>
                    <Col xs={3} md={2}>
                        {props.haydetalleCam?
                        <Button variant="danger" onClick={handleShow}>Liberar</Button>:
                        <Button variant="primary" onClick={props.validarEpp}>Validar</Button>}
                        
                    </Col>
                    <Col xs={9} md={6}>
                        <p><span className={props.validacionEpp.error?'msg-error':'titulo-card'}>{props.validacionEpp.msg}</span></p>
                    </Col>
                </Row>
                <Row >
                    <Card >
                        <Card.Header><span className="titulo-card">PATRONES</span></Card.Header>
                    </Card>
                </Row>
                <Row >
                <Col xs={6} md={4}>
                    <Form.Group className="mb-3" controlId="patron1">
                        <Form.Label><span className="campo">{patron1}</span>
                        </Form.Label>
                        <Form.Select aria-label="Default patron 1 cam" name="patron1"  onChange={props.cambioDetalleCam}>
                              <SelectParam parametro="patron" />
                        </Form.Select>

                    </Form.Group>
                </Col>
                <Col xs={6} md={4}>
                    <Form.Group className="mb-3" controlId="patron2">
                        <Form.Label><span className="campo">{patron2}</span>
                        </Form.Label>
                        <Form.Select aria-label="Default patron 2 cam" name="patron2"  onChange={props.cambioDetalleCam}>
                            <SelectParam parametro="patron" />
                        </Form.Select>
                    </Form.Group>
                </Col>
                </Row>
                <Row >
                    <Card >
                        <Card.Header><span className="titulo-card">PLUMA SUPERIOR</span></Card.Header>
                    </Card>
                </Row>
                <Row >
                    {/* Dielectrico */}
                    <Col xs={3} md={2}>
                            <Form.Group className="mb-3" controlId="plsup_cat">
                            <Form.Label><span className="campo">Categoría</span></Form.Label>
                            <Form.Control
                              name="plsup_cat"
                              type="text"
                              onChange={props.cambioDetalleCam}
                              value={props.dataDetalle.plsup_cat}
                              />
                            </Form.Group>
                    </Col>
                    <Col xs={3} md={2}>
                    <Form.Group className="mb-3" controlId="plsup_ais">
                            <Form.Label><span className="campo">Aislación Eléctrica Medida (GΩ)</span></Form.Label>
                            <Form.Control
                              name="plsup_ais"
                              type="text"
                              value={props.dataDetalle.plsup_ais}
                              onChange={props.cambioDetalleCam}
                              />
                            </Form.Group>
                    </Col>
                </Row>
                <Row >
                    {/* Tabla */}
                    
                    
                    <Col xs={3} md={2}>
                            <Form.Group className="mb-3" controlId="plsup_tension1">
                            <Form.Label><span className="campo">Tensión Aplicada (kV)</span></Form.Label>
                            <Form.Control
                              name="plsup_tension1"
                              type="text"
                              value={props.dataDetalle.plsup_tension1}
                              placeholder='Tensión 1'
                              onChange={props.cambioDetalleCam}
                              />
                            </Form.Group>
                    </Col>
                    <Col xs={3} md={2}>
                    <Form.Group className="mb-3" controlId="plsup_tiempo1">
                            <Form.Label><span className="campo">Tiempo (S)</span></Form.Label>
                            <Form.Control
                              name="plsup_tiempo1"
                              type="text"
                              value={props.dataDetalle.plsup_tiempo1}
                              onChange={props.cambioDetalleCam}
                              />
                            </Form.Group>
                    </Col>
                    <Col xs={3} md={2}>
                    <Form.Group className="mb-3" controlId="plsup_fuga1">
                            <Form.Label><span className="campo">I Fuga (µA)</span></Form.Label>
                            <Form.Control
                              name="plsup_fuga1"
                              type="text"
                              value={props.dataDetalle.plsup_fuga1}
                              onChange={props.cambioDetalleCam}
                              />
                            </Form.Group>
                    </Col>
                    <Col xs={3} md={2}>
                    <Form.Group className="mb-3" controlId="plsup_imax1">
                            <Form.Label><span className="campo">I Máx Fuga Permitida (µA)</span></Form.Label>
                            <Form.Control
                              name="plsup_imax1"
                              type="text"
                              value={props.dataDetalle.plsup_imax1}
                              onChange={props.cambioDetalleCam}
                              />
                            </Form.Group>
                    </Col>
                    <Col >
                        <Form.Label><span className="campo">RESULTADO</span></Form.Label>
                        <Form.Check type="checkbox" id="plsup_ar1" >
                        <Form.Check.Input name="plsup_ar1" type="checkbox" 
                            checked={props.dataDetalle.plsup_ar1}
                            isValid onChange={props.cambioDetalleCam} />
                        <Form.Check.Label>Aprobado</Form.Check.Label>
                        </Form.Check>
                    </Col>
                </Row>
                <Row >
                    {/* Tabla */}
                    <Col xs={3} md={2}>
                            <Form.Group className="mb-3" controlId="form-8">
                            <Form.Control
                              name="plsup_tension2"
                              type="text"
                              value={props.dataDetalle.plsup_tension2}
                              placeholder='Tensión 2'
                              onChange={props.cambioDetalleCam}
                              />
                            </Form.Group>
                    </Col>
                    <Col xs={3} md={2}>
                    <Form.Group className="mb-3" controlId="plsup_tiempo2">
                            <Form.Control
                              name="plsup_tiempo2"
                              type="text"
                              value={props.dataDetalle.plsup_tiempo2}
                              onChange={props.cambioDetalleCam}
                              />
                            </Form.Group>
                    </Col>
                    <Col xs={3} md={2}>
                    <Form.Group className="mb-3" controlId="plsup_fuga2">
                            <Form.Control
                              name="plsup_fuga2"
                              type="text"
                              value={props.dataDetalle.plsup_fuga2}
                              onChange={props.cambioDetalleCam}
                              />
                            </Form.Group>
                    </Col>
                    <Col xs={3} md={2}>
                    <Form.Group className="mb-3" controlId="plsup_imax2">
                            <Form.Control
                              name="plsup_imax2"
                              type="text"
                              value={props.dataDetalle.plsup_imax2}
                              onChange={props.cambioDetalleCam}
                              />
                            </Form.Group>
                    </Col>
                    <Col >
                        <Form.Check  value="plsup_ar2" type="checkbox" id="plsup_ar2" >
                        <Form.Check.Input name="plsup_ar2" type="checkbox" 
                            isValid checked={props.dataDetalle.plsup_ar2} 
                            onChange={props.cambioDetalleCam} />
                        <Form.Check.Label>Aprobado</Form.Check.Label>
                        </Form.Check>
                    </Col>
                </Row>
                <Row >
                    {/* Tabla */}
                    <Col xs={3} md={2}>
                            <Form.Group className="mb-3" controlId="plsup_tension3">
                            <Form.Control
                              name="plsup_tension3"
                              type="text"
                              value={props.dataDetalle.plsup_tension3}
                              placeholder='Tensión 3'
                              onChange={props.cambioDetalleCam}
                              />
                            </Form.Group>
                    </Col>
                    <Col xs={3} md={2}>
                    <Form.Group className="mb-3" controlId="plsup_tiempo3">
                            <Form.Control
                              name="plsup_tiempo3"
                              type="text"
                              value={props.dataDetalle.plsup_tiempo3}
                              onChange={props.cambioDetalleCam}
                              />
                            </Form.Group>
                    </Col>
                    <Col xs={3} md={2}>
                    <Form.Group className="mb-3" controlId="plsup_fuga3">
                            <Form.Control
                              name="plsup_fuga3"
                              type="text"
                              value={props.dataDetalle.plsup_fuga3}
                              onChange={props.cambioDetalleCam}
                              />
                            </Form.Group>
                    </Col>
                    <Col xs={3} md={2}>
                    <Form.Group className="mb-3" controlId="plsup_imax3">
                            <Form.Control
                              name="plsup_imax3"
                              type="text"
                              value={props.dataDetalle.plsup_imax3}
                              onChange={props.cambioDetalleCam}
                              />
                            </Form.Group>
                    </Col>
                    <Col >
                        <Form.Check  value="plsup_ar3" type="checkbox" id="plsup_ar3" >
                        <Form.Check.Input name="plsup_ar3" type="checkbox" 
                            isValid checked={props.dataDetalle.plsup_ar3}
                            onChange={props.cambioDetalleCam} />
                        <Form.Check.Label>Aprobado</Form.Check.Label>
                        </Form.Check>
                    </Col>
                </Row>
                <Row >
                    <Card >
                        <Card.Header><span className="titulo-card">PLUMA INFERIOR</span></Card.Header>
                    </Card>
                </Row>
                <Row >
                    {/* Dielectrico */}
                    <Col xs={3} md={2}>
                            <Form.Group className="mb-3" controlId="plinf_cat">
                            <Form.Label><span className="campo">Categoría</span></Form.Label>
                            <Form.Control
                              name="plinf_cat"
                              type="text"
                              value={props.dataDetalle.plinf_cat}
                              onChange={props.cambioDetalleCam}
                              />
                            </Form.Group>
                    </Col>
                    <Col xs={3} md={2}>
                    <Form.Group className="mb-3" controlId="plinf_ais">
                            <Form.Label><span className="campo">Aislación Eléctrica Medida (GΩ)</span></Form.Label>
                            <Form.Control
                              name="plinf_ais"
                              type="text"
                              value={props.dataDetalle.plinf_ais}
                              onChange={props.cambioDetalleCam}
                              />
                            </Form.Group>
                    </Col>
                </Row>
                <Row >
                    {/* Tabla */}
                    
                    
                    <Col xs={3} md={2}>
                            <Form.Group className="mb-3" controlId="plinf_tension1">
                            <Form.Label><span className="campo">Tensión Aplicada (kV)</span></Form.Label>
                            <Form.Control
                              name="plinf_tension1"
                              type="text"
                              value={props.dataDetalle.plinf_tension1}
                              placeholder='Tensión 1'
                              onChange={props.cambioDetalleCam}
                              />
                            </Form.Group>
                    </Col>
                    <Col xs={3} md={2}>
                    <Form.Group className="mb-3" controlId="plinf_tiempo1">
                            <Form.Label><span className="campo">Tiempo (S)</span></Form.Label>
                            <Form.Control
                              name="plinf_tiempo1"
                              type="text"
                              value={props.dataDetalle.plinf_tiempo1}
                              onChange={props.cambioDetalleCam}
                              />
                            </Form.Group>
                    </Col>
                    <Col xs={3} md={2}>
                    <Form.Group className="mb-3" controlId="plinf_fuga1">
                            <Form.Label><span className="campo">I Fuga (µA)</span></Form.Label>
                            <Form.Control
                              name="plinf_fuga1"
                              type="text"
                              value={props.dataDetalle.plinf_fuga1}
                              onChange={props.cambioDetalleCam}
                              />
                            </Form.Group>
                    </Col>
                    <Col xs={3} md={2}>
                    <Form.Group className="mb-3" controlId="plinf_imax1">
                            <Form.Label><span className="campo">I Máx Fuga Permitida (µA)</span></Form.Label>
                            <Form.Control
                              name="plinf_imax1"
                              type="text"
                              value={props.dataDetalle.plinf_imax1}
                              onChange={props.cambioDetalleCam}
                              />
                            </Form.Group>
                    </Col>
                    <Col >
                        <Form.Label><span className="campo">RESULTADO</span></Form.Label>
                        <Form.Check  value="plinf_ar1" type="checkbox" id="plinf_ar1" >
                        <Form.Check.Input name="plinf_ar1" type="checkbox" 
                            isValid checked={props.dataDetalle.plinf_ar1} 
                            onChange={props.cambioDetalleCam} />
                        <Form.Check.Label>Aprobado</Form.Check.Label>
                        </Form.Check>
                    </Col>
                </Row>
                <Modal show={show} onHide={handleClose} centered>
                  <Modal.Header closeButton>
                    <Modal.Title><span className="titulo-card">ATENCION!!</span></Modal.Title>
                  </Modal.Header>

                  <Modal.Body>
                    <span className="campo">Esta acción borrará los datos de este ensayo de la base de datos. ¿Estás seguro de que deseas realizar esta acción?</span>
                    ¿Estás seguro de que deseas realizar esta operación?
                  </Modal.Body>

                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                      Cancelar
                    </Button>
                    <Button variant="danger" onClick={ejecutarAccion}>
                      Confirmar
                    </Button>
                  </Modal.Footer>
                </Modal>
  </>
   
  )
}

export default ListadoDetalleIngresoCam;